import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const CloseIcon = ({ color = '#FFFFFF', size = '16px', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" {...props}>
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g
        transform="translate(-980.000000, -144.000000)"
        stroke={color}
        strokeWidth="3"
      >
        <g transform="translate(982.000000, 146.000000)">
          <path d="M0,0 L12,12 M11.93315,0.0668529 L0,12" />
        </g>
      </g>
    </g>
  </svg>
);

CloseIcon.propTypes = propTypes;

export default CloseIcon;
